export const firebaseConfig = {
  apiKey: 'AIzaSyD5BqwnntqBqNfn0nqGMItC8R3vyg6u5us',
  authDomain: 'ng-run.firebaseapp.com',
  databaseURL: 'https://ng-run.firebaseio.com',
  projectId: 'ng-run',
  storageBucket: 'ng-run.appspot.com',
};
